module.exports = __webpack_public_path__ + "static/img/NSW-14.2584637.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-14.jpg
// module id = 24DF
// module chunks = 0